import { FC } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { StimLogo } from "../../assets";
import { PublicHeader } from "../../constants/headerLinks";
import { HeaderElementType } from "../../types";



const GuestHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-expand-lg topHead-bar">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/users/sign_in"><img src={StimLogo} alt="Site logo" /></Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-start" id="hubHeader">
          <ul className="navbar-nav">
            {PublicHeader.map((headerLink, index) => (
              <li className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`} key={index}>
                {headerLink.actionType === HeaderElementType.ROUTE ? (
                  <Link className="nav-link custom-text-purple" aria-current="page" to={headerLink.redirectLink}>{headerLink.title}</Link>
                ) : null}
                {headerLink.actionType === HeaderElementType.BUTTON ? (
                  <button className="btn btn-warning rounded-pill custom-text-purple" onClick={() => { navigate(headerLink.redirectLink) }}>
                    {headerLink.title}
                  </button>
                ) : null}
                {headerLink.actionType === HeaderElementType.LINK ? (
                  <a className="nav-link custom-text-purple" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                    {headerLink.title}
                  </a>
                ) : null}
                {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                  <>
                    <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown" aria-expanded="false">
                      {headerLink.title}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end" style={{ top: '53px' }}>
                      {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                        <li key={index}>
                          <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer">
                            {header.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : null}
              </li>
            ))}
            <li className="dropdown nav-item">
              <a
                className="nav-link dropdown-toggle"
                href="." data-bs-toggle="dropdown" aria-expanded="false"
              >
                Resources
              </a>
              <ul className="resources-dropdown dropdown-menu dropdown-center">
                <li>
                  <a
                    className="dropdown-item" href="/assets/completed-request.pdf" target="_blank"
                    rel="noreferrer"
                  >
                    Request Form
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item" href="/assets/SMK-005000-StimRouterReimbursementGuide2024-RevB.pdf" target="_blank"
                    rel="noreferrer"
                  >
                    Reimbursement Guide
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item" href="/assets/MP918-00044-001-Rev.-D-efile-2.pdf" target="_blank"
                    rel="noreferrer"
                  >
                    Statement of Medical Necessity
                  </a>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default GuestHeader;
